import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ProblemCategoryDTO } from '../masterdata/models/problemCategory';
import { ErrorHandler } from '../utils/error-handler';
import { ProblemCategoryService } from './problem-category-service';
import { SelectableLab } from '../carrier/selectable-lab';

@Component({
  selector: 'app-problem-category-template',
  templateUrl: './problem-category-template.component.html',
  styleUrls: ['./problem-category-template.component.css']
})
export class ProblemCategoryTemplateComponent implements OnInit {

  @Input() masterLists: ProblemCategoryDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() checkSelectedLab: SelectableLab;

  labOption: LabMDM[] =[];

  labOptions: LabMDM[];
  isNewMasterList: boolean;
  masterList: ProblemCategoryDTO;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: ProblemCategoryDTO;
  isActive: string = "active";
  isLab: string = "lab";
  isDisplayName: string = "displayName";
  isCategoryName: string = "categoryName";
  isDefaultCategory:string = 'defaultCategory';
  isDisplayList:string = 'displayList';


  constructor(private _messageService: MessagesService, private problemCategoryService: ProblemCategoryService, private _masterDataService : MasterDataService) { }

  ngOnInit() {

  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }   let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

 }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {

    this.isNewMasterList = true;
    this.masterList = new ProblemCategoryDTO;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedLab = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.problemCategoryService.addProblemCategory(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
     this.problemCategoryService.updateProblemCategory(this.masterList).subscribe(
       results => {
         if (!results) {
           return;
         }
         masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
         this.masterLists = masterLists;
         this.masterList = null;
         this.displayMasterListDialog = false;
       },
       error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
         }
     );
  }

  isSaveDisabled() {
    return (this.masterList == undefined || this.masterList.categoryName==null || this.masterList.displayName==null || this.masterList.categoryName == ""
    || this.masterList.displayName == "" || this.selectedLab == null)
  }
}
